import React, { useState } from 'react'
import { MdDelete } from 'react-icons/md'
import ConfirmDeleteSponsor from './ConfirmDeleteSponsor'

export default function ButtonDeleteSposnor({ sponsorId, onClose }) {
  const [isOpen, setIsOpen] = useState(false)
  
    function handleOnOpenModel() {
      setIsOpen(true)
    }
  
    function handleOnCloseModel() {
      setIsOpen(false)
      onClose()
    }
  
    return (
      <>
        <button
          onClick={handleOnOpenModel}
          className="flex w-full items-center gap-4 border-2 border-danger-500 bg-danger-300 px-4 py-2 text-danger-700 hover:bg-danger-500 hover:text-white"
        >
          <MdDelete />
          <div>حذف</div>
        </button>
        <ConfirmDeleteSponsor
          isOpen={isOpen}
          onClose={handleOnCloseModel}
          sponsorId={sponsorId}
        />
      </>
    )
}
